import fetch from 'isomorphic-fetch'
import { authHeader, handleResponse } from './helpers'
import { API_URL } from '../../constants/Config'

export const datasetsService = {
  getDatasets,
  getOneDataset,
  createDataset,
  deleteDataset,
  updateEventsConfig,
  updateLoadingConfig,
  createSubdomain,
  syncArticles,
  getUsage,
  disconnectSubdomain,
  saveArticlesToZendesk,
  deleteArticles,
  reloadArticlesFromZendesk,
  changeArticleStatus,
  cancelTask,
  updateSubdomain
}

async function getDatasets(auth_token, product) {
  const url = `${API_URL}/datasets?product=${product}`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token),
  }
  return fetch(url, options)
    .then((response) => handleResponse(response))
    .then((response) => response.datasets)
}

async function getOneDataset(auth_token, dataset_id, subdomain) {
  let query = ''
  if (subdomain) {
    query += `?subdomain=${subdomain}`
  }
  const url = `${API_URL}/datasets/${dataset_id}${query}`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}

async function createDataset(auth_token, name, source, load, product, data_points) {
  const url = `${API_URL}/datasets?load=${load}&product=${product}`
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({ name, source, data_points }),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}

async function createSubdomain(auth_token, dataset_id, product, data) {
  const url = `${API_URL}/help_center/${dataset_id}/subdomains`
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({ ...data, product }),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}

async function updateEventsConfig(auth_token, dataset_id, events_app, config) {
  const url = `${API_URL}/datasets/${dataset_id}/events/${events_app}`
  const options = {
    method: 'PUT',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(config),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}

async function updateLoadingConfig(auth_token, dataset_id, config) {
  const url = `${API_URL}/datasets/${dataset_id}/loading`
  const options = {
    method: 'PUT',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(config),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}

async function deleteDataset(auth_token, dataset_id) {
  const url = `${API_URL}/datasets/${dataset_id}`
  const options = {
    method: 'DELETE',
    headers: authHeader(auth_token),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}

async function cancelTask(auth_token, dataset_id, type, subdomain) {
  let url = `${API_URL}/datasets/${dataset_id}/tasks/${type}`
  if (subdomain) {
    url += `?subdomain=${subdomain}`
  }
  const options = {
    method: 'DELETE',
    headers: authHeader(auth_token),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}

async function syncArticles(auth_token, dataset_id, product, subdomain, cont) {
  const url = `${API_URL}/datasets/${dataset_id}/tasks/load`
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(subdomain ? { subdomain, cont, product } : {product}),
  }
  // return fetch(url, options); //.then((response) => handleResponse(response))
  return fetch(url, options).then((response) => handleResponse(response))
}

async function deleteArticles(auth_token, data) {
  const url = `${API_URL}/datasets/${data?.dataset_id}/tasks/hcm_delete_articles`
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(data),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}

async function saveArticlesToZendesk(auth_token, data) {
  const url = `${API_URL}/datasets/${data.dataset_id}/tasks/hcm_push_articles`
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(data),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}

async function reloadArticlesFromZendesk(auth_token, data) {
  const url = `${API_URL}/datasets/${data.dataset_id}/tasks/hcm_reload_articles`
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(data),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}

async function changeArticleStatus(auth_token, data) {
  const url = `${API_URL}/datasets/${data.dataset_id}/tasks/hcm_status_change_articles_bulk`
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(data),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}


async function getUsage(auth_token, dataset_id, query) {
  const url = `${API_URL}/datasets/${dataset_id}/app_usage?${new URLSearchParams(query)}`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function disconnectSubdomain(auth_token, dataset_id, subdomain) {
  const url = `${API_URL}/help_center/${dataset_id}/subdomains?subdomain=${subdomain}`
  const options = {
    method: 'DELETE',
    headers: authHeader(auth_token),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function updateSubdomain(auth_token, dataset_id, subdomain, updateData) {
  const url = `${API_URL}/help_center/${dataset_id}/subdomains?subdomain=${subdomain}`;
  const options = {
    method: 'PUT',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(updateData),
  };
  return fetch(url, options).then((response) => handleResponse(response));
}
